module.exports = __webpack_public_path__ + "img/retuern.f9f6183f.png";